import RedirectManager from './RedirectManager'

export default RedirectManager
